import PropTypes from "prop-types";
import React from "react";

import { ButtonGroup } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import styles from "./ButtonGroupAdapter.module.scss";

/**
 * ButtonGroupAdapter renders a list of buttons using button group component
 */

export const ButtonGroupAdapter = (props) => {
  const { placement } = props;

  return <ButtonGroup {...getButtonGroupProps()} />;

  function getButtonGroupProps() {
    const defaultSelectedIndex = -1;
    const buttonList = placement.items.map((item) => ({
      label: item.text,
      props: {
        href: item.props?.target,
        styleType: item.props?.buttonType,
        ...item.props,
      },
    }));

    return {
      alignment: "center",
      "aria-label-next": i18n("ButtonGroupAdapter__BUTTON_GROUP_ARIA_NEXT"),
      "aria-label-previous": i18n("ButtonGroupAdapter__BUTTON_GROUP_ARIA_PREVIOUS"),
      buttonList,
      className: styles.buttonGroup,
      defaultSelectedIndex,
      showSelected: false,
      spaceBetween: "small",
    };
  }
};

ButtonGroupAdapter.displayName = "ButtonGroupAdapter";
ButtonGroupAdapter.propTypes = {
  placement: PropTypes.shape({
    /** Label of each button. */
    label: PropTypes.string,

    /** Object that contains button components props. */
    props: PropTypes.arrayOf(PropTypes.object),
  }),
};
